module.exports = __webpack_public_path__ + "static/media/email.cdcf9e95.svg";